import React from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface EmailsModalProps {
  open: boolean;
  onClose: () => void;
  emails: string[];
  name: string;
}

const EmailsModal: React.FC<EmailsModalProps> = ({ open, onClose, emails, name }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        style: {
          background: '#fff',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.10)',
          borderRadius: 16,
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'transparent',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ color: '#222' }}>Emails de {name}</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ color: '#222' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <List>
          {emails && emails.length > 0 ? (
            emails.map((email, idx) => (
              <ListItem key={idx} divider>
                <ListItemText primary={email} primaryTypographyProps={{ style: { color: '#222' } }} />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No hay emails para mostrar" primaryTypographyProps={{ style: { color: '#222' } }} />
            </ListItem>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default EmailsModal;
